import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {HandoverListItem} from "@handover/view-models/handover-list-item";

@Component({
  selector: 'handovermod-handovers-list-item',
  templateUrl: './handovers-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoversListItemComponent {
  @Input() item?: HandoverListItem;
  @Input() isSelected = false;
}
